export default __webpack_public_path__ + "static/media/logo.a43631c2.png";